import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../../http";
import { useForBindingId } from '../../../forBinding';
import { AreaDTO } from '../../types';
import { getApiErrorMessage, toApiError } from "../utils";
import { createFormData } from "../helpers/createFormdata";

interface RequestUpdateAreaParams {
    propId: string,
    areaId: string,
    data: AreaDTO
}

export function useUpdateArea() {
    const queryClient = useQueryClient();
    const forBinding = useForBindingId();
    const mutate = useMutation({
        mutationFn: async ({ propId, areaId, data }: RequestUpdateAreaParams) => {
            try {
                const form = createFormData(data);
                return (await api.put<AreaDTO>(`/user/prop/${propId}/area/update/${areaId}`, form, {
                    params: { forBinding },
                })).data;
            } catch (error) {
                throw toApiError(error, 'Erro ao atualizar área');
            }
        },
        onSuccess: (_, variables) => {
            queryClient.invalidateQueries({ queryKey: ['areas'] });
            queryClient.invalidateQueries({ queryKey: ['propertyId', variables.propId] });
        },
        onError: (error) => console.error('Erro ao atualizar área:', getApiErrorMessage(error, 'Erro ao atualizar área'))
    })

    return mutate
}
